import { motion } from "framer-motion";

// Shared framer-motion variants + reusable reveal components.

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

// Section reveal wrapper
export const Reveal = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    variants={{
      hidden: { opacity: 0, y: 28 },
      show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay },
      },
    }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line heading reveal
export const LineReveal = ({ lines, className = "" }) => (
  <motion.h1
    className={className}
    initial="hidden"
    animate="show"
    variants={stagger}
    aria-label={lines.join(" ")}
  >
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          variants={{
            hidden: { y: "110%" },
            show: {
              y: "0%",
              transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
            },
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.h1>
);
